import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { hasStoredToken } from "@/utils/auth";
import HomePage from "@/pages/HomePage";

/**
 * Auth-aware router for the root path `/`.
 *
 * Keeps the marketing landing rendered at the strongest URL for SEO (every
 * crawler is unauthenticated) while bouncing authenticated users to the app.
 * The `hasStoredToken` branch prevents a flash of the landing for logged-in
 * users during the brief `useAuth` verification window.
 */
export default function HomeRoute() {
  const { user, isLoading } = useAuth();

  if (!isLoading && user) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isLoading && hasStoredToken()) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div
          data-testid="loading-spinner"
          className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"
        />
      </div>
    );
  }

  return <HomePage />;
}
